import React from 'react'
import { useIntl } from 'react-intl'
import SearchForm, { SearchFormRef } from 'components/Search/SearchForm'
import GlobalSearchContextProvider from 'contexts/GlobalSearch/GlobalSearchContextProvider'
import { GLOBAL_SEARCH_INITIAL_STATE } from 'contexts/GlobalSearch/GlobalSearchState'
import { useGlobalHomesAndVillasSearch } from 'hooks/GlobalSearch/GlobalSearchVerticals/useGlobalHomesAndVillasSearch'
import { HOMES_AND_VILLAS_FILTERS } from 'constants/offerList'
import useLocationSearchLabels from 'hooks/Search/useLocationSearchLabels'

interface Props {
  searchFormRef?: React.Ref<SearchFormRef>
}

function GlobalHomesAndVillasSearchTabContent(props: Props) {
  const { searchFormRef } = props
  const intl = useIntl()
  const locationLabels = useLocationSearchLabels()

  const { globalHomesAndVillasSearchDispatch, globalHomesAndVillasSearchState } = useGlobalHomesAndVillasSearch({
    ...GLOBAL_SEARCH_INITIAL_STATE,
  })

  return <GlobalSearchContextProvider
    state={globalHomesAndVillasSearchState}
    dispatch={globalHomesAndVillasSearchDispatch}
  >
    <SearchForm
      submitOnApply
      saleUnit={intl.formatMessage({
        id: 'PbEclsVbM9',
        defaultMessage: 'Property',
        description: 'Sale unit label for homes and villas occupancy picker (e.g. 1 Property, 2 Properties)',
      })}
      filters={HOMES_AND_VILLAS_FILTERS}
      ref={searchFormRef}
      baseSearchPath="/search/homes-and-villas"
      baseSearchMapPath="/search/homes-and-villas/map"
      locationSearchPlaceholder={locationLabels.homesAndVillasPlaceholderLabel}
    />
  </GlobalSearchContextProvider>
}

export default GlobalHomesAndVillasSearchTabContent
